import { render, staticRenderFns } from "./EditCommissionModal.vue?vue&type=template&id=4bb55d44&"
import script from "./EditCommissionModal.vue?vue&type=script&lang=js&"
export * from "./EditCommissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports